/**
 * Єдине місце мережевої конфігурації веб-клієнта.
 *
 * Аналог `lib/shared/config/app_config.dart` у Flutter-клієнті. Хардкод домену,
 * порту чи шляху деінде — баг, а не стиль: інваріант проєкту вимагає одну точку
 * правди про мережу. Лінт-правило `no-restricted-syntax` тримає це силою.
 */

const SERVER_DOMAIN = 'one2one.hollybyte.com';

const baseHttpsUrl = `https://${SERVER_DOMAIN}`;
const baseWssUrl = `wss://${SERVER_DOMAIN}`;

export const appConfig = {
  serverDomain: SERVER_DOMAIN,

  baseHttpsUrl,
  /** Базовий шлях сигналінгу. Ідентифікатор кімнати додається сегментом. */
  webSocketBaseUrl: `${baseWssUrl}/ws`,

  powChallengeUrl: `${baseHttpsUrl}/api/pow-challenge`,
  turnCredentialsUrl: `${baseHttpsUrl}/api/turn-credentials`,

  termsOfUseUrl: `${baseHttpsUrl}/terms-of-use`,
  privacyPolicyUrl: `${baseHttpsUrl}/privacy-policy`,
  supportUrl: `${baseHttpsUrl}/support`,

  appStoreUrl: 'https://apps.apple.com/us/app/one2one-connect/id6755740505',
  playStoreUrl: 'https://play.google.com/store/apps/details?id=com.hollybyte.one2one',

  /** Таймаут REST-запитів, мс. */
  httpTimeoutMs: 30_000,

  /**
   * Публічні сервери визначення адреси. Використовуються, коли ефемерні
   * креденшли ретрансляції отримати не вдалося (429/503/збій розбору).
   */
  fallbackStunUrls: [
    'stun:stun.l.google.com:19302',
    'stun:stun1.l.google.com:19302',
  ],
} as const;

/**
 * Посилання на кімнату у форматі, який генерують мобільні клієнти зі стору.
 * Міняти не можна: посилання цього вигляду вже розіслані користувачами.
 */
export function buildRoomLink(roomId: string): string {
  return `${appConfig.baseHttpsUrl}/?room=${encodeURIComponent(roomId)}`;
}
